<app-overlay-pop-up
  [openOnHover]="!openOnClick"
  [isDisabled]="disabled"
  [overlayContentClass]="overlayContentClass"
  [blockRepositioning]="blockRepositioning">
  <!-- Trigger Content -->
  <div
    overlay-trigger
    class="{{outerClass}}"
    [ngClass]="(!withArrow && !disabled) ? 'hover-without-arrow' : ''"
    [class.clickable]="!disabled">
    <span
      class="input-title"
      [ngStyle]="{'color': titleColor ? titleColor : '#263238'}"
      *ngIf="title">
      {{title}}<span *ngIf="isRequired" class="red-10">*</span>
    </span>
    <div class="control" [class.disabled]="disabled">
      <div
        data-qa="app-selector-selected-item"
        class="centered-row-container control-text">
        <app-all-icons
          *ngIf="field && selectedItem?.iconNameAndStylingLeft"
          [iconNameAndStyling]="selectedItem.iconNameAndStylingLeft">
        </app-all-icons>
        <span *ngIf="selectedItemStyle" class="padding-right-0p5 {{selectedItemStyle?.class}}">{{selectedItemStyle.text}}</span>
        <ng-container *ngVar="selectedItem ? (isSimpleArray ? selectedItem : (selectedItem[field] ? selectedItem[field] : selectedOption)) : selectedOption as text">
            <span
              class="control-text {{textClass}}"
              id="{{SELECTED_ITEM_ID}}"
              (mouseenter)="activateSelectedItemTooltip(text)"
              (mouseleave)="toolTipSettings.show = false">
              {{text | linkShort : maxLengthSelectedItem}}
            </span>
        </ng-container>
      </div>
      <div class="centered-row-container row-gap-0p25">
        <app-all-icons
          *ngIf="field && selectedItem?.iconNameAndStyling1"
          [iconNameAndStyling]="selectedItem.iconNameAndStyling1">
        </app-all-icons>
        <app-all-icons
          *ngIf="field && selectedItem?.iconNameAndStyling2"
          [iconNameAndStyling]="selectedItem.iconNameAndStyling2">
        </app-all-icons>
        <span
          *ngIf="itemTextField && selectedItem && selectedItem[itemTextField]"
          class="min-width-10 main-8 {{selectedItemStyle?.class}}">
          {{selectedItem[itemTextField] | titlecase}}
        </span>
        <div *ngIf="withArrow" class="suffix">
          <app-all-icons [iconNameAndStyling]="'arrow-down.svg; icon-main-size'"></app-all-icons>
        </div>
      </div>
    </div>
  </div>

  <!-- Overlay Content -->
  <div overlay-content>
    <div>
      <div class="overlay-dropdown">
        <div *ngIf="dataKeys?.length; else emptyState" class="overlay-list">
          <div class="list-block">
            <div *ngIf="checkBoxField" class="list-entry space-between-horizontal-centered border-bottom br-0">
              <app-checkbox
                data-qa="selector-checkbox-option"
                [checked]="checkBoxField.status"
                (change)="checkBoxField.status = !checkBoxField.status;
                  checkBoxFieldClick(checkBoxField.status)">
              </app-checkbox>
              <span class="text-left">{{checkBoxField.title}}</span>
            </div>
            <div *ngIf="buttonField" class="list-entry space-between-horizontal-centered border-bottom br-0">
              <app-button
                data-qa="selector-button-option"
                [type]="buttonField.type"
                [size]="buttonField.size"
                [iconName]="buttonField.iconName"
                (buttonClick)="buttonClick.emit()">
                {{buttonField.text}}
              </app-button>
            </div>
            <div *ngFor="let item of dataKeys; index as i"
                 data-qa="app-selector-list-entry"
                 class="list-entry {{listEntryAdditionalClass}} space-between-horizontal-centered"
                 [class.not-in-table]="isNotInTable"
                 [class.height-1p5]="roundDates && roundDates[i]"
                 [appScrollIntoView]="(isSimpleArray ? item : item[field]) === scrollIntoValue"
                 [class.bg-black-2]="(selectedItem) && (selectedItem === item || (field && selectedItem[field] === item[field]))"
                 [ngClass]="{'no-propagation opacity0p5' : item.disabled }"
                 (click)="onItemSelect(item)">
              <app-all-icons
                *ngIf="field && item.iconNameAndStylingLeft"
                class="padding-right-0p5"
                [iconNameAndStyling]="item.iconNameAndStylingLeft">
              </app-all-icons>
              <div class="space-between-horizontal-centered width-100pcnt">
                <div class="column-flex-end">
                  <app-text-with-tooltip
                    [attr.data-qa]="'selector-item-' + i"
                    [id]="LIST_ITEM_ID + i"
                    [text]="isSimpleArray ? item : item[field]">
                  </app-text-with-tooltip>
                  <span *ngIf="roundDates" class="font-4 opacity0p64 bold500">{{roundDates[i]}}</span>
                </div>
                <div class="centered-row-container row-gap-0p25">
                  <app-all-icons
                    *ngIf="field && item.iconNameAndStyling1"
                    [iconNameAndStyling]="item.iconNameAndStyling1">
                  </app-all-icons>
                  <app-all-icons
                    *ngIf="field && item.iconNameAndStyling2"
                    [iconNameAndStyling]="item.iconNameAndStyling2">
                  </app-all-icons>
                </div>
                <span
                  *ngIf="itemTextField && item[itemTextField]"
                  class="main-8 {{selectedItemStyle?.class}}">
                    {{item[itemTextField] | titlecase}}
                  </span>
              </div>
            </div>
          </div>
        </div>
        <ng-template #emptyState>
          <div *ngIf="buttonField" class="list-entry centered-row-container border-bottom br-0">
            <app-button
              data-qa="selector-button-empty-state"
              [type]="buttonField.type"
              [size]="buttonField.size"
              [iconName]="buttonField.iconName"
              (buttonClick)="buttonClick.emit()">
              {{buttonField.text}}
            </app-button>
          </div>
          <div class="font-3 padding-0p5">No result</div>
        </ng-template>
      </div>
    </div>
  </div>
</app-overlay-pop-up>

<app-tooltip
  *ngIf="toolTipSettings.show"
  [coordinates]="toolTipSettings.coordinates"
  [title]="toolTipSettings.title">
</app-tooltip>
